import favoriteService from './favoriteService';
import favoriteCacheService from './favoriteCacheService';

angular
    .module('sfx.favorites', ['signalview.dashboardUtil'])
    .service('favoriteService', favoriteService)
    .service('favoriteCacheService', favoriteCacheService);
